module.exports = __webpack_public_path__ + "img/login_bg.8c71dfb2.png";